import { render } from "./UiEventsProps.vue?vue&type=template&id=1a68cd2f"
import script from "./UiEventsProps.vue?vue&type=script&lang=js"
export * from "./UiEventsProps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__